export default __webpack_public_path__ + "static/media/google.39ac7505.svg";